<template>
   <notes-search
      @search-updated="$emit('search-updated')" >
    <el-input
      v-test-id="'notes-search-input'"
      slot-scope="{searchQuery, submitSearch}"
      :value="searchQuery"
      @change="submitSearch"
      placeholder="Search"
      :prefix-icon="['far', 'search']"
      data-element="notes"
    />
  </notes-search>
</template>

<script>
import NotesSearch from '#/notes/components/NotesSearch'
export default {
  name: 'NotesSearchInput',
  components: {
    NotesSearch
  }
}
</script>
